export const setUserList = (state, reqResponse) => {
    if (reqResponse.addNewUser) {
        state.userList.splice(0, 0, reqResponse.data);
        state.paginatedUsersList.splice(0, 0, reqResponse.data);
        state.refreshData = "USERS";
    } else if (reqResponse && Array.isArray(reqResponse.data)) {
        state.userList = [...reqResponse.data];
    } else if (reqResponse && reqResponse.data && reqResponse.data.hasOwnProperty("editType")) {
        updateData(state.userList, reqResponse);
        updateData(state.paginatedUsersList, reqResponse);
        state.refreshData = "USERS";
    }
    state.loadingUsers = false;
};

function updateData(data, reqResponse) {
    for (let i = 0; i < data.length; i++) {
        if (data[i].id === reqResponse.data.id) {
            data[i].avatarPath = reqResponse.data.avatarPath;
            data[i].firstName = reqResponse.data.firstName;
            data[i].lastName = reqResponse.data.lastName;
            data[i].email = reqResponse.data.email;
            data[i].language = reqResponse.data.language;
            data[i].department = reqResponse.data.department;
            data[i].position = reqResponse.data.position;
            data[i].phone = reqResponse.data.phone;
            data[i].status = reqResponse.data.status;
            data[i].username = reqResponse.data.username;
            data[i].disabledDatetime = reqResponse.data.disabledDatetime;
            break;
        }
    }
}

export const setPaginatedUsersList = (state, response) => {
    if (response.addItems) {
        state.paginatedUsersList = [...state.paginatedUsersList, ...response.data];
    } else {
        state.paginatedUsersList = [...response.data];
    }
};

export const resetUsers = (state) => {
    state.userList = [];
    state.loadingUsers = true;
};

export const setUserRoleList = (state, reqResponse) => {
    // state.selectedRoleUsers[reqResponse.roleId] = reqResponse.response;
    state.currentUsersForRole = reqResponse && reqResponse.response ? reqResponse.response : [];
};

export const setUsersForEdit = (state, reqResponse) => {
    state.currentUsersForRole = reqResponse.response;
};

export const setCurrentUsersForRole = (state, response) => {
    state.currentUsersForRole = response;
    state.userDDL = state.currentUsersForRole.map(users => ({
        email: users.email,
        value: users.id
    }));
};

export const deleteUser = (state, user) => {
    state.currentUsersForRole.splice(state.currentUsersForRole.indexOf(user), 1);
};

/* add permissions on user */
export const setPermissionsUserList = (state, reqResponse) => {
    state.currentPermissions = reqResponse.response;
};

export const setProcessDetailsAndRoles = (state, permissionsRoles) => {
    state.processDetailsAndRoles = permissionsRoles || {};
};

export const setCurrentPermissionsForUser = (state, response) => {
    state.currentPermissions = response;
    state.permissionsDDL = state.currentPermissions.map(permission => ({
        name: permission.targetId,
        value: permission.targetId
    }));
};
